var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgUnlock = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M6.25,10.2553109 L6.25,7.00606466 C6.24703153,4.05198432 8.48300404,1.57627848 11.4221299,1.27939708 C14.3612558,0.982515677 17.0471529,2.96106297 17.6350004,5.85606466 C17.7174268,6.26199416 17.4551758,6.65788486 17.0492463,6.74031129 C16.6433167,6.82273772 16.247426,6.56048666 16.1649996,6.15455716 C15.7305036,4.01477331 13.7452754,2.55236878 11.572878,2.77180286 C9.40048059,2.99123694 7.74780525,4.82110648 7.75,7.00531091 L7.75,10.2553109 L19,10.2553109 C20.5187831,10.2553109 21.75,11.4865279 21.75,13.0053109 L21.75,20.0053109 C21.75,21.524094 20.5187831,22.7553109 19,22.7553109 L5,22.7553109 C3.48121694,22.7553109 2.25,21.524094 2.25,20.0053109 L2.25,13.0053109 C2.25,11.4865279 3.48121694,10.2553109 5,10.2553109 L6.25,10.2553109 Z M5,11.7553109 C4.30964406,11.7553109 3.75,12.314955 3.75,13.0053109 L3.75,20.0053109 C3.75,20.6956669 4.30964406,21.2553109 5,21.2553109 L19,21.2553109 C19.6903559,21.2553109 20.25,20.6956669 20.25,20.0053109 L20.25,13.0053109 C20.25,12.314955 19.6903559,11.7553109 19,11.7553109 L5,11.7553109 Z"
  }));
};
export default SvgUnlock;